'use client';
import { jsx as _jsx } from "react/jsx-runtime";
// use client directive included since react hooks are used
import { useTheme } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { Error as ErrorFilled } from '@mui/icons-material';
/**
 * Render a configured Toaster provider to enable the
 * creation of toasts using `react-hot-toast`.
 *
 * https://react-hot-toast.com/docs/toaster – Configuring `<Toaster />`
 *
 * https://react-hot-toast.com/docs/toast – Creating toasts
 */
export function ToastProvider() {
    const theme = useTheme();
    return (_jsx(Toaster, { position: "top-center", toastOptions: {
            style: {
                // Enable wider toasts
                maxWidth: '43.75rem',
                fontFamily: theme.typography.fontFamily,
                padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
                minHeight: theme.spacing(4.5),
            },
            success: {
                duration: 4000,
                iconTheme: {
                    primary: theme.palette.success.main,
                    secondary: theme.palette.common.white,
                },
            },
            error: {
                duration: 4000,
                iconTheme: {
                    primary: theme.palette.error.main,
                    secondary: theme.palette.common.white,
                },
                icon: _jsx(ErrorFilled, { color: "error" }),
            },
        } }));
}
